export enum SecondaryNavItemVariants {
  HEAD = 'head',
  CONTENT = 'content',
}
